export default "__VITE_ASSET__Bts$G7Az__"